import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface PasswordIndicatorProps extends FormlyFieldProps {
  hasStoredValue?: boolean;
  class?: string;
}

@Component({
  standalone: false,
  selector: 'formly-field-password-indicator',
  templateUrl: './password-with-indicator.component.html',
  styleUrls: ['./password-with-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldPasswordIndicator extends FieldType<FieldTypeConfig<PasswordIndicatorProps>> {
  get hasStoredValue(): boolean {
    return this.props['hasStoredValue'] === true;
  }

  get showSavedIndicator(): boolean {
    return this.hasStoredValue && !this.formControl.dirty;
  }
}
